import React, { useEffect } from 'react';
import { useFormattingContext } from '../../context/FormattingContext';

interface IAnimatedCounterProps {
  newValue: number;
  updatedValue: number;
  updateValue: (value: number) => void;
  formatWithCurrency?: boolean;
  prevValue?: number;
  duration?: number;
}

const AnimatedCounter = (props: IAnimatedCounterProps) => {
  const { newValue, updatedValue, updateValue, formatWithCurrency = true, prevValue = 0, duration } = props;
  const { formatPrice } = useFormattingContext();

  const DEFAULT_DURATION = 600;
  const HIGH_SPEED_DURATION = 100;

  useEffect(() => {
    const newNumberValue = Number(newValue);
    const prevNumberValue = Number(prevValue);

    if (newNumberValue === prevNumberValue) {
      return;
    }

    const valueDiff = Math.abs(prevNumberValue - newNumberValue);
    const actualDuration = duration ? duration : valueDiff > 1 ? HIGH_SPEED_DURATION : DEFAULT_DURATION;

    const increment =
      newNumberValue > prevNumberValue ? newNumberValue / actualDuration : prevNumberValue / actualDuration;

    let start = prevNumberValue;

    const timer = setInterval(() => {
      if (newNumberValue > prevNumberValue) {
        start += increment;
      } else {
        start -= increment;
      }
      if (
        (newNumberValue > prevNumberValue && start >= newNumberValue) ||
        (newNumberValue < prevNumberValue && start <= newNumberValue)
      ) {
        updateValue(newNumberValue);
        clearInterval(timer);
      } else {
        updateValue(Number(start.toFixed(2)));
      }
    }, 4);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newValue]);

  return <>{formatPrice(updatedValue, formatWithCurrency)}</>;
};

export default AnimatedCounter;
